/**
 * Client session id — one UUID per browser tab (module scope is per-bundle).
 *
 * Sent on every API request as `X-Client-Session-Id`. The backend echoes it
 * into Pusher `transaction.sync` events so the originating tab can ignore
 * its own broadcasts (preventing redundant refetches when the user
 * themselves triggered the mutation in the same tab).
 *
 * Two tabs of the same user each get distinct ids — exactly what we want,
 * since cross-tab sync is desirable.
 */

let _id: string | null = null;

export function getClientSessionId(): string {
  if (_id) return _id;
  _id =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID()
      : `sid-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return _id;
}
